module.exports = __webpack_public_path__ + "static/blank-profile-5a021ab95b4d2a0c8e7511c40ca7bb2f.png";